module.exports = __webpack_public_path__ + "img/u147.3312b24d.png";